<template>
  <!--
    "To Advance" sticker shown in the take-bet modal for outright to-advance
    specials. Styled like the 90+INJ / MUST START pill. The pill itself is the
    hover trigger; the tooltip box reuses InformationalTooltip's exact popper
    styling.
  -->
  <Popper
    class="popper"
    trigger="hover"
    arrow
    placement="top"
    :show="showPopper"
    :z-index="9999"
  >
    <span
      class="to-advance-pill"
      @mouseenter="showPopper = true"
      @mouseleave="showPopper = false"
    >
      To Advance
    </span>
    <template #content>
      <span class="to-advance-tooltip-text">{{ TO_ADVANCE_TOOLTIP }}</span>
    </template>
  </Popper>
</template>

<script setup>
import { ref } from 'vue';
import Popper from 'vue3-popper';
import { TO_ADVANCE_TOOLTIP } from '@/core/utils';

const showPopper = ref(false);
</script>

<style scoped lang="scss">
@use '@/scss/theme/variables.scss' as theme;

// Match the 90+INJ pill exactly (WorldCupInjBadge .inj-90-pill).
.to-advance-pill {
  display: inline-block;
  vertical-align: middle;
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  line-height: 1.4;
  white-space: nowrap;
  cursor: help;
  background: rgba(245, 158, 11, 0.15);
  color: #b45309;
}

[theme='night'] .to-advance-pill {
  background: rgba(251, 191, 36, 0.16);
  color: #fcd34d;
}

// Tooltip content: size to the text up to a sensible max and wrap normally.
// Without an explicit width the popper collapses inside narrow game cells,
// which is what made the copy wrap one word per line.
.to-advance-tooltip-text {
  display: block;
  width: max-content;
  max-width: 220px;
  white-space: normal;
  line-height: 1.4;
  text-align: center;
}

// Tooltip box — same selectors InformationalTooltip uses, so the hover box is
// visually identical (white box, border, shadow, arrow).
:deep(.popper) {
  background: theme.$white_01 !important;
  padding: 8px !important;
  box-shadow: 1px 1px 5px 1px theme.$blue-100 !important;
  color: theme.$black-102 !important;
  width: max-content;
  max-width: 220px;
  font-weight: theme.$font-weight-normal !important;
  font-size: theme.$font-size-xs !important;
  border-radius: 2px !important;
  border: 1px theme.$grey-101 solid !important;
  text-align: center;
}

:deep(.popper #arrow::before) {
  background: theme.$white_01;
}

:deep(.popper:hover),
:deep(.popper:hover > #arrow::before) {
  background: theme.$white_01;
}
</style>
